export const DELETE_DRAFT_REQUEST = 'DELETE_DRAFT_REQUEST';
export const DELETE_DRAFT_SUCCESS = 'DELETE_DRAFT_SUCCESS';
export const DELETE_DRAFT_FAILURE = 'DELETE_DRAFT_FAILURE';

export const DELETE_ALL_DRAFTS_REQUEST = 'DELETE_ALL_DRAFTS_REQUEST';
export const DELETE_ALL_DRAFTS_SUCCESS = 'DELETE_ALL_DRAFTS_SUCCESS';
export const DELETE_ALL_DRAFTS_FAILURE = 'DELETE_ALL_DRAFTS_FAILURE';
